// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

// Styles
const styles = theme => ({
  root: {
    position: 'relative',
    opacity: 0.25,
    transition: theme.transitions.create('opacity'),
  },
  rootActive: {
    opacity: 1,
  },
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    outline: 0,
  },
})

export default
@withStyles(styles)
class ScrollSection extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    onActivation: PropTypes.func,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    // Props below are coming from container
    index: PropTypes.number,
    nodeRef: PropTypes.func,
    isActive: PropTypes.bool,
    onSectionActivate: PropTypes.func,
  }

  static defaultProps = {
    onActivation: () => setImmediate(() => document.activeElement.blur()),
  }

  componentDidMount() {
    const { isActive, disabled, onActivation } = this.props
    if (isActive && !disabled) {
      onActivation()
    }
  }

  componentWillReceiveProps({ isActive, onActivation, disabled }) {
    const { isActive: prevIsActive } = this.props
    if (isActive && !disabled && !prevIsActive) {
      onActivation()
    }
  }

  render() {
    const { classes, nodeRef, children, isActive, disabled, index, onSectionActivate } = this.props
    const active = isActive && !disabled
    const cx = classNames(classes.root, { [classes.rootActive]: active })
    const childProps = { sectionIndex: index, isActive: active, onSectionActivate }
    return (
      <div className={cx} ref={nodeRef}>
        { children(childProps) }
        { !active && <div className={classes.overlay} /> }
      </div>
    )
  }
}
